/**
 * Определяет, является ли устройство планшетом
 * @returns {boolean} true если планшет, false если нет
 */
export const isTabletDevise = () => {
    const ua = navigator.userAgent;
    //console.log('isTabletDevise check, ua:', ua);
    const isIpad = /iPad/.test(ua) ||
        (/(Macintosh)/.test(ua) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) ||
        (window.screen.width === 1366  && window.devicePixelRatio === 2) // iPad Pro 12.9" 
        ;

    const isTablet =
        isIpad ||
        /Android(?!.*Mobile)|Tablet|PlayBook|Silk/i.test(ua);

    return isTablet;
};

/**
 * Определяет, НЕ является ли устройство планшетом
 * @returns {boolean} true если НЕ планшет, false если планшет
 */
export const isDesktop = () => {
    let isDesk = true;
    if (window.innerWidth <= 1280) { 
        isDesk = (
                    window.matchMedia('(any-pointer: fine)').matches || 
                    window.matchMedia('(pointer: fine)').matches // Точный указатель (мышь)
                );
    }
    let isTabletBool = isTabletDevise();
    //console.log('isDesktop check:', {isDesk, isTabletBool, innerWidth: window.innerWidth});
    return (isDesk && !isTabletBool);
};

/**
 * Определяет тип устройства
 * @returns {'mobile' | 'tablet' | 'desktop'}
 */
export const getDeviceType = () => {
    if (isTabletDevise()) return 'tablet';
    
    const isMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase());
    if (isMobile) return 'mobile';
    
    return 'desktop';
};